import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { authRoutes, nonAuthRoutes } from '../const';
import AuthLayout from '../components/AppLayout/AuthLayout';
import NonAuthLayout from '../components/AppLayout/NonAuthLayout';
import { ROUTES } from 'shared/const/routes';
import { getToken, getUserId } from 'shared/config/store/reducers/userSlice';

function AppRouter() {
  const userId = useSelector(getUserId),
    userToken = Boolean(useSelector(getToken));
  const isAuthenticated = userId && userToken;
  const defaultRedirectPage = isAuthenticated ? ROUTES.DASHBOARD.path : ROUTES.LOGIN.path;

  return (
    <Routes>
      {isAuthenticated ? (
        // Авторизованные маршруты
        <Route element={<AuthLayout />}>
          {authRoutes.map((route) => (
            <Route key={route.key} path={route.path} element={route.element} />
          ))}
        </Route>
      ) : (
        // Неавторизованные маршруты
        <Route element={<NonAuthLayout />}>
          {nonAuthRoutes.map((route) => (
            <Route key={route.key} path={route.path} element={route.element} />
          ))}
        </Route>
      )}
      {/* Редирект для несуществующих маршрутов */}
      <Route path="*" element={<Navigate to={defaultRedirectPage} replace />} />
    </Routes>
  );
}

export default AppRouter;
